import React from 'react';
import UtilitiesController from './utilitiesController';
import AuthController from './authController';
import { AsyncStorage, Platform } from 'react-native';

export default class PetController {

    static exceptionWrapper = (fn) => async (data) => {
        try {
            return await fn(data).catch((err) => {
                throw err;
            });
        } catch (err) {
            return {
                success: false,
                error: err.message
                }
        }
    };

    static getAllPets = PetController.exceptionWrapper(async () => {
      let response = await UtilitiesController.get('/api/patient/all', {}, true);

      if(response.success) {
        let pets = response.patients;

        if(pets) {
            pets = pets.map(pet => {
                return {
                name: pet.patient_details[0].name,
                member_role: pet.member_role,
                patient_id: pet.patient_id,
                }
            });

            response = {
                ...response,
                pets
            }
        }
      }

      return response;
    });

    static getPet = PetController.exceptionWrapper(async (patient_id) => {
        let response = await UtilitiesController.get(`/api/patient/${patient_id}`, {}, true);
  
        return response;
    });

    static updatePet = PetController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.update(`/api/patient/${data.patient_id}`, data, true);
  
        return response;
    });

    static addPet = PetController.exceptionWrapper(async (data) => {
        let response = await UtilitiesController.post(`/api/patient`, data, true);
  
        return response;
    })

}
